import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ------------------------Get Notification-------------------
export const getNotificationApi = async (data) => {
  const endPoint =
    `notification/notification_list` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// ------------------------Add Notification------------------
export const addNotificationApi = async (data) => {
  const endPoint = `notification/send_notification`;
  return await axios.post(endPoint, data, setJwtToken());
};

// -------------------------Delete Notification ------------
export const deleteNotificationApi = async (data) => {
  const endPoint = `notification/cancel_scheduled_notification/${data}`;
  return await axios.get(endPoint, setJwtToken());
};

// ------------------------Send BroadCast notification------------------
export const sendBroadCastApi = async (data) => {
  const endPoint = `notification/send_broadCast`;
  return await axios.post(endPoint, data, setMultiPartHeader());
};
//----------------notifications-API---------------------------

// -------------------------user-list------------
export const getUSerListApi = async (data) => {
  const endPoint =
    `notification/users` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// ------------------------send Notification------------------
export const sendNotificationApi = async (data) => {
  const endPoint = `notification/send`;
  return await axios.post(endPoint, data, setJwtToken());
};

// ------------------------Get-Notification-list------------------
export const getNotificationListApi = async (data) => {
  const endPoint =
    `notification/list` + "?" + new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};
